module.exports = __webpack_public_path__ + "img/taobaozhibo1.5f3ddf42.png";